export default __webpack_public_path__ + "static/media/SIW100G_M024_W10.982826ce.webp";